import React, { ReactNode } from 'react';
import { Card, Flex, Gap, Icon, Text } from '@common/components';
import { ColorsType } from '@common/tokens';

export function OfferPreviewCard({
  action,
  actionerName,
  candidateName,
  actionedAt,
  isExtension,
  children,
  headerText,
}: {
  action: string;
  actionerName: string;
  candidateName: string;
  actionedAt: ReactNode;
  isExtension: boolean;
  children: ReactNode;
  headerText: ReactNode;
}) {
  const iconColorMap = {
    accepted: 'meadowDarker',
    rejected: 'coral',
    rejected_by_approver: 'coral',
    retracted: 'sunDarkest',
    sent: 'skyRegular',
    cancelled: 'coral',
  };

  const iconColor = iconColorMap[
    action as keyof typeof iconColorMap
  ] as ColorsType;

  return (
    <Card className="OfferPreviewCard">
      <Flex align="center" justify="space-between" fullWidth>
        <Gap align="center" size="md">
          {iconColor && (
            <Icon icon="circle" kind="solid" size="md" color={iconColor} />
          )}
          <section className="card-body sentry-mask">
            <Text>
              {headerText || (
                <>
                  <Text bold>{isExtension ? 'Extension ' : ''} Offer: </Text>
                  <Text bold transform="capitalize">
                    {action === 'rejected_by_approver' ? 'rejected' : action}
                  </Text>{' '}
                  by {actionerName} for {candidateName}
                </>
              )}
            </Text>
            {actionedAt && (
              <Text secondary block>
                {actionedAt}
              </Text>
            )}
          </section>
        </Gap>
        <div>{children}</div>
      </Flex>
    </Card>
  );
}
